import { render, staticRenderFns } from "./ClicColInterno.vue?vue&type=template&id=2da7cd4e&scoped=true&"
import script from "./ClicColInterno.vue?vue&type=script&lang=js&"
export * from "./ClicColInterno.vue?vue&type=script&lang=js&"
import style0 from "./ClicColInterno.vue?vue&type=style&index=0&id=2da7cd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da7cd4e",
  null
  
)

export default component.exports